'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../../utils/getThemeProp.js');
require('../../utils/colors.js');
require('../../utils/dates.js');
require('../../utils/numbers.js');
require('../../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../../utils/strings.js');
require('../../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
var Button = _interopDefault(require('@material-ui/core/Button'));
require('../../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../../utils/safeFetch.js');
require('../../utils/dom.js');

var StyledButton = styled__default(Button)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  text-transform: none;\n  .MuiButton-startIcon {\n    margin-right: 0;\n    margin-bottom: 0.12rem;\n    svg {\n      margin-right: 4px;\n    }\n  }\n  .MuiButton-endIcon {\n    margin-left: 0;\n    margin-bottom: 0.12rem;\n    svg {\n      margin-left: 4px;\n    }\n  }\n  svg {\n    fill: ", ";\n    height: 100%;\n    width: 1rem;\n  }\n"], ["\n  text-transform: none;\n  .MuiButton-startIcon {\n    margin-right: 0;\n    margin-bottom: 0.12rem;\n    svg {\n      margin-right: 4px;\n    }\n  }\n  .MuiButton-endIcon {\n    margin-left: 0;\n    margin-bottom: 0.12rem;\n    svg {\n      margin-left: 4px;\n    }\n  }\n  svg {\n    fill: ",
    ";\n    height: 100%;\n    width: 1rem;\n  }\n"])), function (props) {
    return getThemeProp("palette." + (props.disabled ? 'neutrals.inactive' : 'text.hint'));
});
var templateObject_1;

module.exports = StyledButton;
